(function () {
  const U = window.UIX;
  const Core = window.RB.Core;
  const APP = window.APP;

  const el = U.el;
  const esc = U.esc;
  const menuCfg = U.menuCfg;
  const saveMenuCfg = U.saveMenuCfg;
  const artImg = U.artImg;
  const ribbon = U.ribbon;
  const BK = (U.BuilderKit = U.BuilderKit || {});
  BK.fitPool = function () { fitPool(); };
  BK.runeIcon = function (dom, cls) { return runeIcon(dom, cls); };

  function openBuilder(base) {
    let deck;
    if (base) {
      deck = JSON.parse(JSON.stringify(base));
      delete deck.builtin;
      if (!Array.isArray(deck.side)) deck.side = [];
      if (base.builtin) {
        deck.id = "custom-" + Date.now();
        deck.name = base.name + " (copy)";
      }
    } else {
      deck = {
        id: "custom-" + Date.now(),
        name: "New Deck",
        tagline: "",
        legend: null,
        champion: null,
        battlefields: [],
        runes: {},
        deck: [],
        side: [],
      };
    }
    APP.builder = {
      deck: deck,
      search: "",
      sel: deck.champion || deck.legend || null,
      page: 0,
      filters: { domains: {}, types: {}, energy: {}, rarity: {} },
    };
    APP.screen = "builder";
    U.render();
  }

  function runeIcon(dom, cls) {
    const c = RB.Setup.findCard(RB.Decklists.RUNE_CARDS[dom]);
    const tile = el("div", "msct msrunei" + (cls ? " " + cls : ""));
    tile.title = dom;
    if (c) tile.appendChild(artImg(c, ""));
    return tile;
  }

  function poolCards() {
    const out = [];
    for (const c of window.CARD_DB) {
      const t = c.types || [];
      if (c.token) continue;
      if (t.indexOf("unit") < 0 && t.indexOf("spell") < 0 && t.indexOf("gear") < 0) continue;
      if (t.indexOf("legend") >= 0 || t.indexOf("battlefield") >= 0 || t.indexOf("rune") >= 0) continue;
      out.push(c);
    }
    out.sort(function (a, b) { return a.name.localeCompare(b.name); });
    return out;
  }

  function cardsOfType(type) {
    const out = window.CARD_DB.filter(function (c) {
      return (c.types || []).indexOf(type) >= 0 && !c.token;
    });
    out.sort(function (a, b) { return a.name.localeCompare(b.name); });
    return out;
  }

  const RARITIES = [
    ["common", "#9fb2cd"], ["uncommon", "#7bd88f"], ["rare", "#6bb7ff"],
    ["epic", "#c98bff"], ["showcase", "#f0c46a"],
  ];
  const POOL_TYPES = ["unit", "spell", "gear"];
  const POOL_PAGE = 24;

  function poolPer() {
    const b = APP.builder;
    return (b && b.per) || POOL_PAGE;
  }

  function fitPool() {
    const b = APP.builder;
    const grid = BK.poolGrid;
    if (!b || !grid || !grid.isConnected) return;
    const land = BK.poolLand;
    const fit = window.UIDOM.gridFit(grid, {
      min: land ? 112 : 84,
      maxCols: land ? 4 : 0,
      ratio: land ? window.UIDOM.LAND_RATIO : window.UIDOM.CARD_RATIO,
      gap: 7,
    });
    if (fit.per !== b.per) { b.per = fit.per; U.render(); }
  }

  window.UIDOM.onResize(function () {
    if (APP.screen === "builder") U.render();
  });
  const MAX_COPIES = RB.Decklists.MAX_COPIES;
  const DECK_SIZE = RB.Decklists.DECK_SIZE;
  const RUNE_TOTAL = RB.Decklists.RUNE_TOTAL;
  const SIDE_MAX = RB.Decklists.SIDE_MAX;
  const BATTLEFIELDS = RB.Decklists.BATTLEFIELDS;

  function builderState() {
    const b = APP.builder;
    if (!b.filters) b.filters = { domains: {}, types: {}, energy: {}, rarity: {} };
    if (b.page === undefined) b.page = 0;
    if (b.sel === undefined) b.sel = null;
    if (!Array.isArray(b.deck.side)) b.deck.side = [];
    return b;
  }

  function pile(deck, where) {
    if (!Array.isArray(deck.side)) deck.side = [];
    return where === "side" ? deck.side : deck.deck;
  }

  function limitOf(where) {
    return where === "side" ? SIDE_MAX : DECK_SIZE;
  }

  function capOf(id) {
    return RB.Decklists.copyCap(RB.Setup.findCard(id));
  }

  function copiesOf(deck, id, where) {
    let n = 0;
    for (const x of pile(deck, where)) if (x === id) n++;
    return n;
  }

  function totalCopies(deck, id) {
    return copiesOf(deck, id, "main") + copiesOf(deck, id, "side");
  }

  function addCopy(deck, id, where) {
    const list = pile(deck, where);
    if (list.length >= limitOf(where)) return false;
    if (totalCopies(deck, id) >= capOf(id)) return false;
    list.push(id);
    return true;
  }

  function removeCopy(deck, id, where) {
    const list = pile(deck, where);
    const i = list.lastIndexOf(id);
    if (i < 0) return false;
    list.splice(i, 1);
    if (deck.champion === id && copiesOf(deck, id, "main") === 0) deck.champion = null;
    return true;
  }

  function pileName(where) {
    return where === "side" ? "Side" : "Main";
  }

  function whyNoAdd(deck, id, where) {
    const c = RB.Setup.findCard(id);
    if (where === "side" && c && !RB.Decklists.isMainDeckCard(c)) {
      return "The side deck holds main deck cards only.";
    }
    if (pile(deck, where).length >= limitOf(where)) {
      return pileName(where) + " deck is full at " + limitOf(where) + ".";
    }
    const cap = capOf(id);
    if (totalCopies(deck, id) >= cap) {
      return "Already at " + cap + " " + (cap === 1 ? "copy" : "copies") + " of " + (c ? c.name : id) +
        (deck.side.length ? " between main and side deck." : ".");
    }
    return null;
  }

  function roomFor(deck, id, where) {
    return Math.max(0, Math.min(capOf(id) - totalCopies(deck, id), limitOf(where) - pile(deck, where).length));
  }

  function bnote(text, tone) {
    const b = APP.builder;
    if (b) b.note = text ? { text: text, tone: tone || "" } : null;
  }

  function countLine(deck) {
    return "Main " + deck.deck.length + "/" + DECK_SIZE +
      (deck.side.length ? " · Side " + deck.side.length + "/" + SIDE_MAX : "");
  }

  function addCards(deck, id, n, where) {
    where = where || "main";
    const c = RB.Setup.findCard(id);
    let done = 0;
    while (done < n && addCopy(deck, id, where)) done++;
    if (!done) { bnote(whyNoAdd(deck, id, where), "bad"); return false; }
    bnote((c ? c.name : id) + " — " + totalCopies(deck, id) + " in deck · " + countLine(deck), "good");
    return true;
  }

  function cutCards(deck, id, n, where) {
    where = where || "main";
    const c = RB.Setup.findCard(id);
    let done = 0;
    while (done < n && removeCopy(deck, id, where)) done++;
    if (!done) { bnote("No copies of " + (c ? c.name : id) + " in the " + pileName(where).toLowerCase() + " deck.", "bad"); return false; }
    bnote((c ? c.name : id) + " — " + totalCopies(deck, id) + " in deck · " + countLine(deck), "cut");
    return true;
  }

  function moveCards(deck, id, n, from, to) {
    const c = RB.Setup.findCard(id);
    let done = 0;
    while (done < n && copiesOf(deck, id, from) > 0 && pile(deck, to).length < limitOf(to)) {
      removeCopy(deck, id, from);
      pile(deck, to).push(id);
      done++;
    }
    if (!done) {
      bnote(copiesOf(deck, id, from) ? pileName(to) + " deck is full at " + limitOf(to) + "." :
        "No copies of " + (c ? c.name : id) + " to move.", "bad");
      return false;
    }
    if (to === "side" && deck.champion === id && copiesOf(deck, id, "main") === 0) deck.champion = null;
    bnote((c ? c.name : id) + " — moved to the " + pileName(to).toLowerCase() + " deck · " + countLine(deck),
      to === "side" ? "cut" : "good");
    return true;
  }

  function runeCut(deck, dom, all) {
    const have = (deck.runes || {})[dom] || 0;
    if (!have) { bnote("No " + dom + " runes to remove.", "bad"); return false; }
    deck.runes[dom] = all ? 0 : have - 1;
    if (!deck.runes[dom]) delete deck.runes[dom];
    bnote("Runes " + runeTotal(deck) + "/" + RUNE_TOTAL, "cut");
    return true;
  }

  function addRunes(deck, dom, all) {
    if (runeTotal(deck) >= RUNE_TOTAL) { bnote("Rune deck is full at " + RUNE_TOTAL + ".", "bad"); return false; }
    const room = RUNE_TOTAL - runeTotal(deck);
    deck.runes[dom] = (deck.runes[dom] || 0) + (all ? room : 1);
    bnote("Runes " + runeTotal(deck) + "/" + RUNE_TOTAL, "good");
    return true;
  }

  function runeTotal(deck) {
    let n = 0;
    for (const d in deck.runes || {}) n += deck.runes[d];
    return n;
  }

  function cardTile(card, opts) {
    const o = opts || {};
    const tile = el("div", "msct" + (o.land ? " land" : "") + (o.dim ? " dim" : "") + (o.sel ? " sel" : ""));
    tile.title = o.title || (card ? card.name : "");
    if (card) {
      tile.dataset.card = card.id;
      if (o.where) tile.dataset.where = o.where;
      if (o.dom) tile.dataset.dom = o.dom;
      tile.appendChild(artImg(card, ""));
    }
    if (o.qty) tile.appendChild(el("div", "bbqty", esc(String(o.qty))));
    if (o.tag) tile.appendChild(el("div", "bbin", esc(o.tag)));
    if (o.onclick) tile.onclick = o.onclick;
    return tile;
  }

  function emptyTile(label, land) {
    const tile = el("div", "msct bbslot" + (land ? " land" : ""));
    tile.appendChild(el("span", "mslbl", esc(label)));
    return tile;
  }

  const PICKS = {
    legend: {
      label: "Legend",
      short: "Legend",
      message: "Choose a Legend — click one. Esc cancels.",
      rows: { domains: true, types: false, energy: false, rarity: true },
      pool: function () { return cardsOfType("legend"); },
      set: function (deck, id) { deck.legend = id; },
    },
    champion: {
      label: "Chosen Champion",
      short: "Champion",
      message: "Choose your Chosen Champion from the champion units in your 40. Esc cancels.",
      pool: function (deck) {
        const seen = {}, out = [];
        for (const id of deck.deck) {
          const c = RB.Setup.findCard(id);
          if (c && (c.supertypes || []).indexOf("champion") >= 0 && !seen[c.id]) {
            seen[c.id] = true;
            out.push(c);
          }
        }
        return out;
      },
      rows: { domains: true, types: false, energy: true, rarity: true },
      set: function (deck, id) { deck.champion = id; },
      empty: "Add a champion unit to the deck first.",
    },
    battlefield: {
      label: "Battlefield",
      short: "Battlefield",
      message: "Choose a Battlefield — click one. Esc cancels.",
      rows: { domains: true, types: false, energy: false, rarity: true },
      land: true,
      pool: function (deck) {
        const b = APP.builder;
        const taken = {};
        const fields = deck.battlefields || [];
        for (let i = 0; i < fields.length; i++) {
          if (b && b.pickIdx === i) continue;
          taken[fields[i]] = true;
        }
        return cardsOfType("battlefield").filter(function (c) { return !taken[c.id]; });
      },
      set: function (deck, id) {
        const b = APP.builder;
        const i = b && b.pickIdx !== undefined && b.pickIdx !== null ? b.pickIdx : 0;
        if (!deck.battlefields) deck.battlefields = [];
        deck.battlefields[i] = id;
      },
    },
  };

  function startPick(slot, idx) {
    const b = builderState();
    const spec = PICKS[slot];
    b.pickIdx = idx === undefined ? null : idx;
    if (spec.empty && !spec.pool(b.deck).length) { bnote(spec.empty, "bad"); U.render(); return; }
    b.pick = slot;
    b.page = 0;
    b.stash = { filters: b.filters, search: b.search };
    b.filters = { domains: {}, types: {}, energy: {}, rarity: {} };
    b.search = "";
    bnote(spec.message, "");
    U.render();
  }

  function endPick() {
    const b = APP.builder;
    if (!b || !b.pick) return false;
    b.pick = null;
    b.pickIdx = null;
    b.page = 0;
    if (b.stash) { b.filters = b.stash.filters; b.search = b.stash.search; b.stash = null; }
    bnote("", "");
    U.render();
    return true;
  }

  function choosePick(id) {
    const b = builderState();
    const spec = PICKS[b.pick];
    spec.set(b.deck, id);
    const c = RB.Setup.findCard(id);
    b.pick = null;
    b.pickIdx = null;
    b.page = 0;
    if (b.stash) { b.filters = b.stash.filters; b.search = b.stash.search; b.stash = null; }
    b.sel = id;
    bnote((c ? c.name : id) + " set as " + spec.label + ".", "good");
    U.render();
  }

  function slotButton(slot, card, opts) {
    const o = opts || {};
    const b = APP.builder;
    const picking = b && b.pick === slot &&
      (o.idx === undefined || b.pickIdx === o.idx);
    const wrap = el("div", "bbslotpick" + (picking ? " picking" : "") + (o.land ? " land" : ""));
    const tile = card
      ? cardTile(card, { land: o.land, sel: b && b.sel === card.id })
      : emptyTile(o.empty || PICKS[slot].label, o.land);
    tile.className += " bbslottile";
    tile.title = picking
      ? "Choosing — click a card on the right, or click here to cancel"
      : (card ? card.name + " — click to change" : "Click to choose a " + PICKS[slot].label.toLowerCase());
    tile.onclick = function () { if (picking) endPick(); else startPick(slot, o.idx); };
    if (picking) tile.appendChild(el("span", "bbslothint", "Cancel"));
    wrap.appendChild(tile);
    return wrap;
  }

  function heroSlot(slot, card, opts) {
    const o = opts || {};
    const row = el("div", "bbslotrow");
    row.appendChild(slotButton(slot, card, o));
    const meta = el("div", "bbslotmeta");
    meta.appendChild(el("span", "mslbl bbslotkey", esc(PICKS[slot].short || PICKS[slot].label)));
    const parts = card ? card.name.split(", ") : [];
    meta.appendChild(el("div", "bbslotname" + (card ? "" : " empty"), esc(card ? parts[0] : "Not chosen")));
    const sub = el("div", "bbslotsub");
    for (const dom of (card && card.domains) || []) sub.appendChild(runeIcon(dom));
    sub.appendChild(el("span", "mslbl", esc(card && parts.length > 1 ? parts.slice(1).join(", ") : (card ? "" : "Click the frame"))));
    meta.appendChild(sub);
    row.appendChild(meta);
    return row;
  }

  function fieldSlots(deck) {
    const fields = deck.battlefields || [];
    const row = el("div", "bbslotrow bbfieldrow");
    const meta = el("div", "bbslotmeta bbfieldmeta");
    meta.appendChild(el("span", "mslbl bbslotkey", "Battlefields"));
    meta.appendChild(el("div", "bbslotname" + (fields.length === BATTLEFIELDS ? "" : " empty"),
      esc(fields.length + " / " + BATTLEFIELDS)));
    row.appendChild(meta);
    const wrap = el("div", "bbfields");
    for (let i = 0; i < BATTLEFIELDS; i++) {
      const card = fields[i] ? RB.Setup.findCard(fields[i]) : null;
      wrap.appendChild(slotButton("battlefield", card, { land: true, idx: i, empty: "Battlefield " + (i + 1) }));
    }
    row.appendChild(wrap);
    return row;
  }

  function renderCardDetail(b, deck) {
    const pane = el("div", "mspane msbev bbdetailpane");
    const inner = el("div", "mspanein msbev bbdetail");
    pane.appendChild(inner);

    const card = b.sel ? RB.Setup.findCard(b.sel) : null;
    const head = el("div", "bbhead");
    head.appendChild(el("span", "mslbl", "Card detail"));
    head.appendChild(el("span", "msnum bbcode", esc(card ? card.public_code || "" : "")));
    inner.appendChild(head);

    const fig = el("div", "bbart" + (card ? "" : " bbartempty"));
    if (card) {
      fig.appendChild(el("div", "bbartglow"));
      fig.appendChild(artImg(card, "bbartimg", { sizes: "520px" }));
    } else {
      fig.appendChild(el("span", "mslbl", "Pick a card to inspect it"));
    }
    inner.appendChild(fig);

    const parts = card ? card.name.split(", ") : [];
    const names = el("div", "bbnames");
    names.appendChild(el("div", "bbcname" + (card ? "" : " empty"), esc(card ? parts[0] : "No card selected")));
    names.appendChild(el("div", "mslbl bbcsub", esc(parts.length > 1 ? parts.slice(1).join(", ") : "")));
    inner.appendChild(names);

    const chips = el("div", "bbchips");
    if (card) {
      const supers = card.supertypes || [];
      const kind = (supers.length ? supers[0] + " " : "") + (card.types || []).join(" ");
      chips.appendChild(el("span", "bbchip hot", esc(kind)));
      for (const t of card.tags || []) chips.appendChild(el("span", "bbchip", esc(t)));
    }
    inner.appendChild(chips);

    const stats = el("div", "bbstats");
    const cost = el("div", "bbstat");
    cost.appendChild(el("span", "mslbl", "Cost"));
    const costVal = el("span", "bbstatrow");
    costVal.appendChild(el("span", "bbep msnum", card && card.energy !== undefined && card.energy !== null ? String(card.energy) : "—"));
    for (const dom of (card && card.domains) || []) costVal.appendChild(runeIcon(dom));
    cost.appendChild(costVal);
    stats.appendChild(cost);
    const might = el("div", "bbstat");
    might.appendChild(el("span", "mslbl", "Might"));
    might.appendChild(el("span", "bbstatnum msnum", card && card.might !== undefined && card.might !== null ? String(card.might) : "—"));
    stats.appendChild(might);
    const rar = el("div", "bbstat");
    rar.appendChild(el("span", "mslbl", "Rarity"));
    const rarVal = el("span", "bbrarname", esc(String((card && card.rarity) || "—").toUpperCase()));
    for (const r of RARITIES) if (card && r[0] === card.rarity) rarVal.style.color = r[1];
    rar.appendChild(rarVal);
    stats.appendChild(rar);
    inner.appendChild(stats);

    const inMain = card ? copiesOf(deck, card.id, "main") : 0;
    const inSide = card ? copiesOf(deck, card.id, "side") : 0;
    const cap = card ? capOf(card.id) : MAX_COPIES;
    const step = el("div", "bbstep");
    const minus = el("button", "bbstepb", "−");
    minus.disabled = !card || inMain === 0;
    minus.onclick = function (e) { cutCards(deck, card.id, e && e.shiftKey ? MAX_COPIES : 1, "main"); U.render(); };
    step.appendChild(minus);
    const pips = el("div", "bbpips");
    for (let i = 0; i < cap; i++) {
      pips.appendChild(el("span", "bbpip" + (i < inMain ? " on" : i < inMain + inSide ? " side" : "")));
    }
    step.appendChild(pips);
    const count = el("div", "bbstepn");
    count.appendChild(el("span", "mslbl", inSide ? "Main · side" : "In deck"));
    count.appendChild(el("span", "msnum", inSide ? inMain + " · " + inSide : String(inMain)));
    step.appendChild(count);
    const plus = el("button", "bbstepb plus", "+");
    plus.disabled = !card || !!whyNoAdd(deck, card.id, "main");
    plus.title = card ? (whyNoAdd(deck, card.id, "main") || "Add a copy to the main deck") : "";
    plus.onclick = function (e) { addCards(deck, card.id, e && e.shiftKey ? roomFor(deck, card.id, "main") : 1, "main"); U.render(); };
    step.appendChild(plus);
    inner.appendChild(step);

    const sideRow = el("div", "bbsidestep");
    sideRow.appendChild(el("span", "mslbl", "Side deck"));
    const sideCut = el("button", "bbstepb", "−");
    sideCut.disabled = !card || inSide === 0;
    sideCut.title = "Remove a copy from the side deck";
    sideCut.onclick = function (e) { cutCards(deck, card.id, e && e.shiftKey ? MAX_COPIES : 1, "side"); U.render(); };
    sideRow.appendChild(sideCut);
    sideRow.appendChild(el("span", "msnum", String(inSide)));
    const sideAdd = el("button", "bbstepb plus", "+");
    sideAdd.disabled = !card || !!whyNoAdd(deck, card.id, "side");
    sideAdd.title = card ? (whyNoAdd(deck, card.id, "side") || "Add a copy to the side deck") : "";
    sideAdd.onclick = function (e) { addCards(deck, card.id, e && e.shiftKey ? roomFor(deck, card.id, "side") : 1, "side"); U.render(); };
    sideRow.appendChild(sideAdd);
    const toSide = el("button", "btn ghost small", inMain ? "Move to side" : "Move to main");
    const mainFull = deck.deck.length >= DECK_SIZE;
    const sideFull = deck.side.length >= SIDE_MAX;
    const blocked = inMain ? sideFull : mainFull;
    toSide.disabled = !card || (!inMain && !inSide) || blocked;
    toSide.title = blocked
      ? (inMain
        ? "The side deck is full at " + SIDE_MAX + " — cut one first."
        : "The main deck is full at " + DECK_SIZE + " — cut a card from it first.")
      : inMain
        ? "Move one copy from the main deck to the side deck"
        : "Move one copy from the side deck to the main deck";
    toSide.onclick = function () {
      if (inMain) moveCards(deck, card.id, 1, "main", "side");
      else moveCards(deck, card.id, 1, "side", "main");
      U.render();
    };
    sideRow.appendChild(toSide);
    inner.appendChild(sideRow);

    return pane;
  }

  function renderCurve(deck) {
    const pane = el("div", "mspane msbev bbcurvepane");
    const inner = el("div", "mspanein msbev bbcurve");
    pane.appendChild(inner);

    const curve = U.deckCurve(deck);
    const buckets = curve.buckets;
    const kinds = { unit: curve.units, spell: curve.spells, gear: curve.gear };
    const total = curve.total;
    const avg = curve.avg.toFixed(1);

    const head = el("div", "bbhead");
    head.appendChild(el("span", "mslbl", "Energy curve"));
    const avgWrap = el("span", "bbavg");
    avgWrap.appendChild(el("span", "mslbl", "Avg"));
    avgWrap.appendChild(el("span", "msnum", avg));
    head.appendChild(avgWrap);
    inner.appendChild(head);

    const peak = U.peakOf(buckets);
    const chart = el("div", "bbchart");
    for (let e = 0; e < buckets.length; e++) {
      const col = el("div", "bbcol");
      col.appendChild(el("span", "bbcoln msnum", String(buckets[e])));
      const track = el("div", "bbtrack");
      const bar = el("div", "bbbar");
      bar.style.height = buckets[e] ? Math.max(4, Math.round((buckets[e] / peak) * 100)) + "%" : "0";
      track.appendChild(bar);
      col.appendChild(track);
      col.appendChild(el("span", "bbcole msnum", e === 7 ? "7+" : String(e)));
      chart.appendChild(col);
    }
    inner.appendChild(chart);

    const split = el("div", "bbsplit");
    const colors = { unit: "var(--fury)", spell: "var(--order)", gear: "var(--mind)" };
    for (const t of POOL_TYPES) {
      if (!kinds[t]) continue;
      const seg = el("div", "bbseg");
      seg.style.width = ((kinds[t] / (total || 1)) * 100) + "%";
      seg.style.background = colors[t];
      split.appendChild(seg);
    }
    inner.appendChild(split);

    const legend = el("div", "bblegend");
    for (const t of POOL_TYPES) {
      const item = el("span", "bblegitem");
      const dot = el("span", "bbdot");
      dot.style.background = colors[t];
      item.appendChild(dot);
      item.appendChild(el("span", "mslbl", t.charAt(0).toUpperCase() + t.slice(1) + "s"));
      item.appendChild(el("span", "msnum", String(kinds[t])));
      legend.appendChild(item);
    }
    inner.appendChild(legend);

    return pane;
  }

  function byCurve(x, y) {
    const cx = RB.Setup.findCard(x);
    const cy = RB.Setup.findCard(y);
    const ex = cx ? cx.energy || 0 : 0;
    const ey = cy ? cy.energy || 0 : 0;
    if (ex !== ey) return ex - ey;
    return (cx ? cx.name : x).localeCompare(cy ? cy.name : y);
  }

  function renderDeckPane(b, deck) {
    const pane = el("div", "mspane msbev bbmid");
    const inner = el("div", "mspanein msbev bbdeckpane");
    pane.appendChild(inner);

    const legend = deck.legend ? RB.Setup.findCard(deck.legend) : null;
    const champ = deck.champion ? RB.Setup.findCard(deck.champion) : null;

    const hero = el("div", "bbhero");
    if (legend) {
      hero.appendChild(artImg(legend, "bbheroart", { sizes: "700px" }));
      hero.appendChild(el("div", "bbherofade"));
    }
    const slots = el("div", "bbslots");
    slots.appendChild(heroSlot("legend", legend, {}));
    slots.appendChild(heroSlot("champion", champ, { empty: "Champion" }));
    slots.appendChild(fieldSlots(deck));
    hero.appendChild(slots);
    inner.appendChild(hero);

    const mainSect = el("div", "mssect bbmain");
    mainSect.appendChild(ribbon("Main Deck", deck.deck.length + " / " + DECK_SIZE, "bbrib"));
    mainSect.dataset.zone = "main";
    const grid = el("div", "bbgrid");
    const sorted = deck.deck.slice().sort(byCurve);
    for (const id of sorted) {
      (function (id) {
        const c = RB.Setup.findCard(id);
        if (!c) return;
        const tile = cardTile(c, {
          sel: b.sel === id,
          where: "main",
          title: c.name + " — left-click to inspect, right-click to cut a copy",
          onclick: function () { b.sel = id; U.render(); },
        });
        const drop = el("button", "bbdrop", "−");
        drop.title = "Remove one copy";
        drop.onclick = function (e) {
          if (e && e.stopPropagation) e.stopPropagation();
          cutCards(deck, id, 1);
          U.render();
        };
        tile.appendChild(drop);
        grid.appendChild(tile);
      })(id);
    }
    if (!deck.deck.length) grid.appendChild(el("div", "msempty bbspan", "Empty — add cards from the collection."));
    mainSect.appendChild(grid);
    inner.appendChild(mainSect);

    const lower = el("div", "bblower");

    const sideSect = el("div", "mssect bbsidesect");
    sideSect.appendChild(ribbon("Side Deck", deck.side.length + " / " + SIDE_MAX, "bbrib"));
    const sideGrid = el("div", "bbside");
    sideGrid.dataset.zone = "side";
    const sortedSide = deck.side.slice().sort(byCurve);
    for (const id of sortedSide) {
      (function (id) {
        const c = RB.Setup.findCard(id);
        if (!c) return;
        sideGrid.appendChild(cardTile(c, {
          sel: b.sel === id,
          where: "side",
          title: c.name + " — left-click to inspect, right-click to cut a copy, drag onto the main deck to swap it in",
          onclick: function () { b.sel = id; U.render(); },
        }));
      })(id);
    }
    for (let i = deck.side.length; i < SIDE_MAX; i++) sideGrid.appendChild(el("div", "msct bbslot"));
    sideSect.appendChild(sideGrid);
    lower.appendChild(sideSect);

    const runeSect = el("div", "mssect bbrunesect");
    const rt = runeTotal(deck);
    runeSect.appendChild(ribbon("Rune Deck", rt + " / " + RUNE_TOTAL, "bbrib"));
    const runeGrid = el("div", "bbrunes");
    runeGrid.dataset.zone = "runes";
    for (const dom of Core.DOMAINS) {
      const n = (deck.runes || {})[dom] || 0;
      for (let i = 0; i < n; i++) {
        (function (dom) {
          const c = RB.Setup.findCard(RB.Decklists.RUNE_CARDS[dom]);
          const tile = cardTile(c, {
            sel: c && b.sel === c.id,
            where: "runes",
            dom: dom,
            title: (c ? c.name : dom) + " — left-click to inspect, right-click to remove",
            onclick: function () { if (c) { b.sel = c.id; U.render(); } },
          });
          runeGrid.appendChild(tile);
        })(dom);
      }
    }
    for (let i = rt; i < RUNE_TOTAL; i++) runeGrid.appendChild(el("div", "msct bbslot"));
    runeSect.appendChild(runeGrid);
    lower.appendChild(runeSect);
    inner.appendChild(lower);

    const tools = el("div", "bbtools");
    const runeAdd = el("div", "bbruneadd");
    runeAdd.appendChild(el("span", "mslbl", "Add rune"));
    for (const dom of Core.DOMAINS) {
      (function (dom) {
        const pip = runeIcon(dom, "big clicky");
        pip.title = "Add a " + dom + " rune";
        pip.onclick = function (e) {
          addRunes(deck, dom, !!(e && e.shiftKey));
          U.render();
        };
        runeAdd.appendChild(pip);
      })(dom);
    }
    tools.appendChild(runeAdd);
    const clearSide = el("button", "btn ghost", "Clear side");
    clearSide.disabled = !deck.side.length;
    clearSide.title = "Empty the side deck";
    clearSide.onclick = function () {
      if (!confirm("Remove all " + deck.side.length + " cards from the side deck?")) return;
      deck.side = [];
      U.render();
    };
    tools.appendChild(clearSide);
    const clear = el("button", "btn danger", "Clear deck");
    clear.disabled = !deck.deck.length;
    clear.onclick = function () {
      if (!confirm("Remove all " + deck.deck.length + " cards from the main deck?")) return;
      deck.deck = [];
      deck.champion = null;
      U.render();
    };
    tools.appendChild(clear);
    inner.appendChild(tools);

    return pane;
  }

  function poolMatches(b, base, rows) {
    const f = b.filters;
    const q = (b.search || "").trim().toLowerCase();
    const domOn = rows.domains ? Object.keys(f.domains).filter(function (k) { return f.domains[k]; }) : [];
    const typeOn = rows.types ? Object.keys(f.types).filter(function (k) { return f.types[k]; }) : [];
    const energyOn = rows.energy ? Object.keys(f.energy).filter(function (k) { return f.energy[k]; }) : [];
    const rarOn = rows.rarity ? Object.keys(f.rarity).filter(function (k) { return f.rarity[k]; }) : [];
    return base.filter(function (c) {
      if (typeOn.length && !typeOn.some(function (t) { return (c.types || []).indexOf(t) >= 0; })) return false;
      if (domOn.length && !domOn.some(function (d) { return (c.domains || []).indexOf(d) >= 0; })) return false;
      if (rarOn.length && rarOn.indexOf(c.rarity) < 0) return false;
      if (energyOn.length) {
        const e = c.energy || 0;
        const key = e >= 7 ? "7" : String(e);
        if (energyOn.indexOf(key) < 0) return false;
      }
      if (!q) return true;
      if (c.name.toLowerCase().indexOf(q) >= 0) return true;
      if ((c.tags || []).some(function (t) { return t.toLowerCase().indexOf(q) >= 0; })) return true;
      if ((c.keywords || []).some(function (k) { return String(k.name).toLowerCase().indexOf(q) >= 0; })) return true;
      return (c.text || "").toLowerCase().indexOf(q) >= 0;
    });
  }

  function renderCollection(b, deck) {
    const pane = el("div", "mspane msbev bbright");
    const inner = el("div", "mspanein msbev bbcollection");
    pane.appendChild(inner);
    const f = b.filters;
    const picking = b.pick ? PICKS[b.pick] : null;
    const rows = picking ? picking.rows : { domains: true, types: true, energy: true, rarity: true };

    const searchRow = el("div", "bbsearch");
    searchRow.appendChild(el("span", "bbsearchicon",
      "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round'><circle cx='10.5' cy='10.5' r='6.5'></circle><path d='M15.4 15.4 20 20'></path></svg>"));
    searchRow.appendChild(U.searchField({
      id: "bsearch",
      placeholder: picking ? "Search " + picking.label + "s — name, tag, keyword, text" : "Search Origins — name, tag, keyword, text",
      value: b.search || "",
      onInput: function (value) {
        b.search = value;
        b.page = 0;
        U.render();
      },
    }));
    inner.appendChild(searchRow);

    const toggle = function (bag, key) {
      return function () {
        if (bag[key]) delete bag[key]; else bag[key] = true;
        b.page = 0;
        U.render();
      };
    };

    const filters = el("div", "bbfilters");

    if (rows.domains) {
    const domRow = el("div", "bbfrow");
    domRow.appendChild(el("span", "mslbl bbfkey", "Domain"));
    const domWrap = el("div", "bbfvals");
    for (const dom of Core.DOMAINS) {
      const pip = runeIcon(dom, "big clicky" + (f.domains[dom] ? "" : " off"));
      pip.onclick = toggle(f.domains, dom);
      domWrap.appendChild(pip);
    }
    domRow.appendChild(domWrap);
    filters.appendChild(domRow);
    }

    if (rows.types) {
    const typeRow = el("div", "bbfrow");
    typeRow.appendChild(el("span", "mslbl bbfkey", "Type"));
    const typeWrap = el("div", "bbfvals");
    for (const t of POOL_TYPES) {
      const chip = el("span", "bbchip clicky" + (f.types[t] ? " on" : ""), t.charAt(0).toUpperCase() + t.slice(1));
      chip.onclick = toggle(f.types, t);
      typeWrap.appendChild(chip);
    }
    typeRow.appendChild(typeWrap);
    filters.appendChild(typeRow);
    }

    if (rows.energy) {
    const enRow = el("div", "bbfrow");
    enRow.appendChild(el("span", "mslbl bbfkey", "Energy"));
    const enWrap = el("div", "bbfvals");
    for (let e = 0; e <= 7; e++) {
      (function (e) {
        const key = String(e);
        const pip = el("span", "bbep msnum clicky" + (f.energy[key] ? " on" : " off"), e === 7 ? "7+" : key);
        pip.onclick = toggle(f.energy, key);
        enWrap.appendChild(pip);
      })(e);
    }
    enRow.appendChild(enWrap);
    filters.appendChild(enRow);
    }

    const rarRow = el("div", "bbfrow");
    rarRow.appendChild(el("span", "mslbl bbfkey", rows.rarity ? "Rarity" : ""));
    const rarWrap = el("div", "bbfvals");
    if (rows.rarity) for (const r of RARITIES) {
      (function (r) {
        const dot = el("span", "bbrar clicky" + (f.rarity[r[0]] ? " on" : ""));
        dot.style.background = r[1];
        dot.title = r[0];
        dot.onclick = toggle(f.rarity, r[0]);
        rarWrap.appendChild(dot);
      })(r);
    }
    rarRow.appendChild(rarWrap);
    const reset = el("span", "bbchip clicky bbreset", "Reset filters");
    reset.onclick = function () {
      b.filters = { domains: {}, types: {}, energy: {}, rarity: {} };
      b.search = "";
      b.page = 0;
      U.render();
    };
    rarRow.appendChild(reset);
    filters.appendChild(rarRow);
    inner.appendChild(filters);

    if (b.pick) {
      const bar = el("div", "bbpickbar");
      bar.appendChild(el("span", "bbpickmsg", esc(PICKS[b.pick].message)));
      const cancel = el("button", "btn ghost", "Cancel");
      cancel.onclick = function () { endPick(); };
      bar.appendChild(cancel);
      inner.appendChild(bar);
    }

    const matches = poolMatches(b, picking ? picking.pool(deck) : poolCards(), rows);
    const per = poolPer();
    const pages = Math.max(1, Math.ceil(matches.length / per));
    if (b.page >= pages) b.page = pages - 1;

    const head = el("div", "bbhead bbcolhead");
    head.appendChild(el("span", "mslbl", picking ? "Choose a " + picking.label : "Collection"));
    head.appendChild(el("span", "msnum bbcolnum", String(matches.length)));
    head.appendChild(el("span", "mslbl", picking ? "selectable" : "cards match"));
    inner.appendChild(head);

    const grid = el("div", "bbpool" + (picking ? " picking" : "") + (picking && picking.land ? " land" : ""));
    grid.dataset.zone = "collection";
    BK.poolGrid = grid;
    BK.poolLand = !!(picking && picking.land);
    const page = matches.slice(b.page * per, (b.page + 1) * per);
    for (const c of page) {
      (function (c) {
        if (picking) {
          grid.appendChild(cardTile(c, {
            land: b.pick === "battlefield",
            sel: b.sel === c.id,
            where: "pick",
            title: c.name + " — click to set as " + picking.label,
            onclick: function () { choosePick(c.id); },
          }));
          return;
        }
        const n = totalCopies(deck, c.id);
        const inSide = copiesOf(deck, c.id, "side");
        const full = !!whyNoAdd(deck, c.id, "main") && !!whyNoAdd(deck, c.id, "side");
        grid.appendChild(cardTile(c, {
          qty: n || null,
          tag: n ? "IN " + n + (inSide ? " · " + inSide + " SIDE" : "") : null,
          dim: full,
          sel: b.sel === c.id,
          where: "collection",
          title: c.name + (full ? " — at maximum" : " — left-click to inspect, right-click to add a copy"),
          onclick: function () { b.sel = c.id; U.render(); },
        }));
      })(c);
    }
    inner.appendChild(grid);

    const pager = el("div", "bbpager");
    const step = function (label, to, on) {
      const p = el("span", "bbpg" + (on ? " on" : ""), label);
      p.onclick = function () { b.page = to; U.render(); };
      return p;
    };
    pager.appendChild(step("‹", Math.max(0, b.page - 1), false));
    const from = Math.max(0, Math.min(b.page - 2, pages - 5));
    for (let i = from; i < Math.min(pages, from + 5); i++) {
      pager.appendChild(step(String(i + 1), i, i === b.page));
    }
    pager.appendChild(step("›", Math.min(pages - 1, b.page + 1), false));
    pager.appendChild(el("span", "mslbl bbpginfo", per + " per page · " + pages + " pages"));
    inner.appendChild(pager);

    pane.onwheel = function (ev) {
      const dir = ev.deltaY > 0 ? 1 : ev.deltaY < 0 ? -1 : 0;
      if (!dir) return;
      ev.preventDefault();
      const now = Date.now();
      if (now - bWheelAt < 240) return;
      const to = Math.min(pages - 1, Math.max(0, b.page + dir));
      if (to === b.page) return;
      bWheelAt = now;
      b.page = to;
      U.render();
    };

    return pane;
  }

  let bWheelAt = 0;

  Object.assign(BK, { openBuilder: openBuilder, MAX_COPIES: MAX_COPIES, SIDE_MAX: SIDE_MAX, builderState: builderState, copiesOf: copiesOf, totalCopies: totalCopies, moveCards: moveCards, whyNoAdd: whyNoAdd, roomFor: roomFor, bnote: bnote, addCards: addCards, cutCards: cutCards, runeCut: runeCut, endPick: endPick, renderCardDetail: renderCardDetail, renderCurve: renderCurve, renderDeckPane: renderDeckPane, renderCollection: renderCollection });
  Object.assign(U, { openBuilder: openBuilder });
})();
